const FormatNumberWithFraction = (value, fractionDigits = 2) => {
  let result = value;

  // No caso de valor tipo numérico, caso a fração autal seja maior do  que o número desejado,
  // ocorrerá o arredondaemnto aproximado.
  // Para evitar o arredondamento, informe o valor no formato string

  switch (typeof result) {
    case 'number':
      return result.toLocaleString('pt-BR', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits });
    case 'string':
      /* istanbul ignore else */
      if (result.indexOf('.') !== -1) {
        if (result.split('.')[1].length > fractionDigits) {
          while (result.split('.')[1].length > fractionDigits) {
            result = result.slice(0, -1);
          }
        } else {
          while (result.split('.')[1].length < fractionDigits) {
            result = `${result}0`;
          }
        }
        result = `${Number(result.split('.')[0]).toLocaleString('pt-BR')},${result.split('.')[1]}`;
      }
      return result;
    default:
      return result;
  }
};

export default FormatNumberWithFraction;
